export default __webpack_public_path__ + "static/media/analytics.9988ae26.svg";